import React from 'react';
import { Trans, useTranslation } from 'next-i18next';

import { IconButton } from 'components';
import { ButtonV3 } from 'components/ComponentV2';
import Modal from 'components/Modal';

import styles from './AdditionalBadgeModal.module.scss';

export enum AdditionalBadgeModalType {
  INVISIBLE_TO_RECRUITERS = 'invisible-to-recruiters',
  AUTOFILL_APPLICATIONS = 'autofill-applications',
  ALMOST_DONE = 'almost-done',
  PROFILE_COMPLETED = 'profile-completed',
}

type AdditionalBadgeModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  modalType: AdditionalBadgeModalType | null;
};

export const AdditionalBadgeModal: React.FC<AdditionalBadgeModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  modalType,
}) => {
  const [t] = useTranslation('candidate.profile');
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentClassName={styles['modal-content']}
      closeOnOverlayClick={false}
      className={styles.modal}
    >
      <section className={styles.container}>
        <section className={styles['title-bar']}>
          <p className={styles.emoji}>{t(`sidebar.${modalType}.emoji`)}</p>
          <p className={styles['title-text']}>
            {t(`sidebar.${modalType}.title`)}
          </p>
        </section>
        <p className={styles.detail}>
          {modalType === 'profile-completed' && (
            <p className={styles['pre-detail']}>
              {t(`sidebar.${modalType}.pre-description`)}
            </p>
          )}
          <Trans t={t} i18nKey={`sidebar.${modalType}.description`}>
            <span className={styles.highlight}></span>
            <span className={styles.highlight}></span>
          </Trans>
        </p>
        <footer className={styles.footer}>
          <ButtonV3 isFullWidth onClick={onConfirm || onClose}>
            {t(`sidebar.${modalType}.cta`)}
          </ButtonV3>
        </footer>
        <IconButton
          iconName="close"
          size="small"
          className={styles.close}
          onClick={onClose}
        />
      </section>
    </Modal>
  );
};
